import { render, staticRenderFns } from "./ERTIGAXL7BOOSTERGREEN.vue?vue&type=template&id=5f77cdae&"
import script from "./ERTIGAXL7BOOSTERGREEN.vue?vue&type=script&lang=ts&"
export * from "./ERTIGAXL7BOOSTERGREEN.vue?vue&type=script&lang=ts&"
import style0 from "./ERTIGAXL7BOOSTERGREEN.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports